import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useRootStore = defineStore('root', () => {
  // States
  const _isMonthlySummaryDisplayed = ref<boolean>(true);
  const _isMobilePlatform = ref<boolean>(false);
  const _canHideMonthlySummary = ref<boolean>(false);

  // Getters
  const isMonthlySummaryDisplayed = computed(() => _isMonthlySummaryDisplayed.value);
  const isMobilePlatform = computed(() => _isMobilePlatform.value);
  const canHideMonthlySummary = computed(() => _canHideMonthlySummary.value);

  // Actions
  function onScreenResizeAction(isMobilePlatform: boolean) {
    _isMobilePlatform.value = isMobilePlatform;
    if (isMobilePlatform) {
      hideMonthlySummary();
    } else {
      showMonthlySummary();
    }
  }

  function showMonthlySummary() {
    _isMonthlySummaryDisplayed.value = true;
    return _isMonthlySummaryDisplayed.value;
  }

  function hideMonthlySummary() {
    _isMonthlySummaryDisplayed.value = false;
    return _isMonthlySummaryDisplayed.value;
  }

  function toggleMonthlySummary() {
    _isMonthlySummaryDisplayed.value = !_isMonthlySummaryDisplayed.value;
    return _isMonthlySummaryDisplayed.value;
  }

  function monthlySummaryCanBeHided() {
    _canHideMonthlySummary.value = true;
    return _canHideMonthlySummary.value;
  }

  function monthlySummaryCannotBeHided() {
    _canHideMonthlySummary.value = false;
    return _canHideMonthlySummary.value;
  }

  return {
    isMonthlySummaryDisplayed,
    isMobilePlatform,
    canHideMonthlySummary,

    onScreenResizeAction,
    hideMonthlySummary,
    toggleMonthlySummary,
    monthlySummaryCanBeHided,
    monthlySummaryCannotBeHided,
  };
});

export default useRootStore;
